'use strict';

/* globals RELATIVE_PATH */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	Vue.component('lesson-completed', {
		props: ['initData'],
		computed: {
			hasGoodbyeContent: function () {
				return this.initData.lesson.goodbyeContent && this.initData.lesson.goodbyeContent.length;
			},
		},
		template:
		'<div class="text-center">' +
			'<div style="white-space: pre;" v-show="hasGoodbyeContent">{{initData.lesson.goodbyeContent}}</div>' +
			'<span v-show="!hasGoodbyeContent">{{initData.translations.endOfLesson}}</span>' +
		'</div>',
	});
});
